
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getTicketDetail, getCheckTicket } from '@/api/xiecheng'
import { PROD_LIST_ITEM, PRODUCTS_ITEM } from '@/api/xiecheng-api'
import { CalculationnNum, formatDate } from '@/utils/tool'
import CreateRelation from '@/components/CreateRelation/index.vue'
@Component({
  name: 'ticketDetail',
  components: {
    CreateRelation
  }
})
export default class ticketDetail extends Vue {
  private loading = true; // 设置为true是为了先展示骨架屏
  private defaultImg = 'http://qnimg.zowoyoo.com/img/84826/1680261061590.png';
  private infoId = '';
  private current = 0;
  private activeName = '1'; // 产品详情tab选中
  private bannerList = [] as Array<string>; // 轮播图片
  private detail = {} as PROD_LIST_ITEM; // 产品详情信息
  private products = [] as Array<PRODUCTS_ITEM>; // 相关产品
  private startDay = formatDate(+new Date(), 'Y-M-D'); // 开始日期
  private createShow = false; // 绑定分销商弹框
  private parentCustId = '';
  private dbLink = '';

  @Watch('$route')
  infoIdChange (newValue: any): void {
    if (newValue && newValue.query.infoId !== undefined) {
      this.infoId = newValue.query.infoId
      this.handleDetail()
    }
  }

  CalculationnNum = CalculationnNum;

  // 产品列表
  handleDetail () {
    this.loading = true
    getTicketDetail({ infoId: this.infoId }).then(res => {
      this.loading = false
      this.detail = res.ticketInfoVo
      this.products = res.ticketInfoVo.products || []
      this.handleBanner(res.ticketInfoVo.img, res.ticketInfoVo.signImg)
    })
  }

  // 处理轮播图
  handleBanner (arrString: string, img: string) {
    this.bannerList = []
    if (arrString) {
      const arr = arrString.split(',')
      this.bannerList = arr.slice(0, 5)
    } else {
      const imgStr = img || this.defaultImg
      this.bannerList.push(imgStr)
    }
  }

  // 轮播图切换
  changeBanner (value: any) {
    this.current = value
  }

  // 切换tab选项卡
  private handleClick (tab, event) {
    console.log(tab, event)
    console.log(tab.label, tab.name)
  }

  // 打开地图
  private clickMap = (latitude: string, longitude: string) => {
    if (latitude && longitude) {
      const url = `http://api.map.baidu.com/geocoder?location=${latitude},${longitude}&coord_type=bd09ll&output=html&src=zowoyoo`
      window.open(url, '_blank')
    }
  };

  // 跳转到 b2c 页面
  private clickTitle (ojb, e) {
    this.loading = true
    const { infoId, parentCustId, dbLink } = ojb
    getCheckTicket({ infoId: infoId, sdate: this.startDay }).then(res => {
      this.loading = false
      if (res && res.refStatus === 0) {
        this.openToC(ojb, e)
      } else {
        this.parentCustId = parentCustId
        this.dbLink = dbLink
        this.createShow = true
      }
    })
  }

  private openToC (ojb, e) {
    const mchWebSite = this.detail.mchWebSite || 'pdd.zowoyoo.com'
    const { infoId, treeId } = ojb
    window.open(
      `http://${mchWebSite}/newb2c/productdetail/${infoId}?treeId=${treeId}`,
      '_blank',
      `top=${e.screenY + 20},left=${e.screenX -
        187},width=375,height=667,fullscreen=1,menubar=0,resizable=0,toolbar=0,scrollbars=0,status=0,location=0,directories=0`
    )
  }

  mounted () {
    const { infoId } = this.$route.query
    if (infoId) {
      this.infoId = String(infoId)
      this.handleDetail()
    } else {
      this.$message({
        type: 'error',
        message: '产品ID获取错误'
      })
      this.$router.go(-1)
    }
  }
}
